import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { logEvent } from '~/config/firebase.config';

import styles from './DualScreen.module.css';

/** Double écran demandé sans la formule Pro : ce qu'il apporte, et où passer en Pro. */
export function ProUpsell({ clientID, onClose }: { clientID: string; onClose?: () => void }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {
        logEvent('dual_screen_upsell', clientID, { clientID });
    }, [clientID]);
    return (
        <div className={styles.upsell}>
            <span className={styles.tag}>{t('regie.upsell.tag')}</span>
            <h2 className={styles.title}>{t('regie.upsell.title')}</h2>
            <ul className={styles.points}>
                <li>{t('regie.upsell.p1')}</li>
                <li>{t('regie.upsell.p2')}</li>
                <li>{t('regie.upsell.p3')}</li>
            </ul>
            <div className={styles.actions}>
                <button
                    type="button"
                    className={styles.primary}
                    onClick={() => {
                        logEvent('dual_screen_upsell_click', clientID, { clientID });
                        navigate('/account/brand', { state: { clientID } });
                    }}
                >
                    {t('regie.upsell.cta')}
                </button>
                <button type="button" className={styles.secondary} onClick={onClose ?? (() => navigate('/home'))}>
                    {t('regie.upsell.later')}
                </button>
            </div>
        </div>
    );
}
